var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77659 5.2385L10.4527 5.92421C6.77489 6.65519 4 9.94208 4 13.8863C4 18.3674 7.58172 22 12 22C16.4183 22 20 18.3674 20 13.8863C20 9.94208 17.2251 6.6552 13.5473 5.92421L14.2234 5.2385C14.6021 4.85442 14.6021 4.23172 14.2234 3.84764L12.6857 2.28805C12.307 1.90398 11.693 1.90398 11.3143 2.28805L9.77659 3.84764C9.3979 4.23172 9.3979 4.85442 9.77659 5.2385ZM5.45455 13.8863C5.45455 10.2199 8.38505 7.24779 12 7.24779C15.615 7.24779 18.5455 10.2199 18.5455 13.8863C18.5455 17.5526 15.615 20.5248 12 20.5248C8.38505 20.5248 5.45455 17.5526 5.45455 13.8863Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.161bd86611567136966e440ca2e8f381.svg";
export { ForwardRef as ReactComponent };